import { render, staticRenderFns } from "./stuArchives.vue?vue&type=template&id=6a03ec27"
import script from "./stuArchives.vue?vue&type=script&lang=js"
export * from "./stuArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports